import { Grid, Typography } from '@mui/material';
import CustomTooltip from 'components/custom-tooltip';
import { getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { convertBytes } from 'utils/helpers';
import { styles } from './styles';
import { DeletedActionsPopper } from '../deleted-actions-popper';
import DotIcon from 'assets/icons/cabinet/dot.svg';
import dayjs from 'dayjs';

interface IDeletedFileCard {
  type: string;
  name: string;
  mimeType?: string;
  size: number | string;
  deletedAt: Date;
  onViewFile: () => void;
  onDeleteFile: () => void;
  onRestoreFile: () => void;
}

export const DeletedFileCard = ({
  name,
  type,
  mimeType,
  size,
  deletedAt,
  onViewFile,
  onDeleteFile,
  onRestoreFile,
}: IDeletedFileCard) => {
  const Icon = getRowIcon(type, mimeType);

  return (
    <>
      <Grid sx={styles.container} onClick={onViewFile}>
        <Grid sx={styles.card}>
          <Grid sx={styles.cardHeader}>
            <Icon className={'file-icon'} />
            <DeletedActionsPopper onRestoreFile={onRestoreFile} onDeleteFile={onDeleteFile} />
          </Grid>
          <Grid sx={styles.cardContent}>
            <Grid sx={styles.contentContainer}>
              <CustomTooltip title={name}>
                <Typography sx={styles.folderName}>{name}</Typography>
              </CustomTooltip>
              <Grid sx={styles.details}>
                <Typography sx={styles.typo}>{convertBytes(Number(size), 2)}</Typography>
                <DotIcon />
                <Typography sx={styles.typo}>{dayjs(deletedAt).format('D/M/YYYY')}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
